import { Helmet } from "react-helmet-async";

const SITE_NAME = "Avinya Bookings";
const DEFAULT_DESC = "Book farmhouses, resorts, banquet halls and function halls around Hyderabad. Book. Relax. Celebrate.";

// Public production site URL (env-driven, domain-ready). Falls back to current origin.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");

export const Seo = ({ title, description, path = "", image, type = "website", jsonLd }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Book. Relax. Celebrate.`;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${path}`;
  const img = image || `${SITE_URL}/og-default.jpg`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
